import * as React from "react";
import { Component } from "react";
import * as moment from "moment";
import "./TimeTable.css";
import { WEEKDAYS_LONG } from "../constants/DateConsts";
import { SchedulerService } from "../services/SchedulerService";
import { ShowStatusBar } from "../components/Layout/GlobalStatusBar";
import { DEFAULT_STATUS_TIMEOUT } from "../constants/SystemConsts";
import { ITimeTable } from "../models/ITimeTable";

interface IProps {
    TimeTable: ITimeTable;
    OnHourClick: (
        date: Date,
        physiotherapistId: string,
        clinicId: number | undefined
    ) => void;
    MaxDayLength: number;
    PhysiotherapistId: string;
}

interface IState {
    ShowMore: boolean;
    WindowSize: number;
}

export class TimeTableComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowMore: false,
            WindowSize: window.innerWidth
        };

        this.OnMoreButtonClick = this.OnMoreButtonClick.bind(this);
        this.OnLessButtonClick = this.OnLessButtonClick.bind(this);
        this.HasMoreItems = this.HasMoreItems.bind(this);
        this.OnRequestSchedulerActivationClick = this.OnRequestSchedulerActivationClick.bind(
            this
        );
    }

    public componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    public render() {
        let days: JSX.Element[] = [];
        let notEmptyDayPushed = false;
        for (let day of this.props.TimeTable.TimeTableDay) {
            days.push(
                <div
                    key={this.props.PhysiotherapistId + '_' + day.Day.getTime()}
                    className={
                        "time-table-day " +
                        (notEmptyDayPushed === false && day.Hours.length > 0
                            ? "first-not-empty"
                            : "")
                    }
                >
                    {day.Hours.length > 0 ? (
                        <div className="day-label">
                            <b>{WEEKDAYS_LONG[day.Day.getDay()]}&nbsp;&nbsp;</b>
                            {day.Day.toLocaleDateString()}
                        </div>
                    ) : null}
                    
                    {day.Hours.length > 0 ? (
                        day.Hours.filter(
                            (i, index) =>
                                index < this.props.MaxDayLength ||
                                this.state.ShowMore
                        ).map(hour => (
                            <div
                                key={this.props.PhysiotherapistId + '_' + day.Day.getTime() + "_" + hour.StartHour}
                                onClick={this.OnHourClick.bind(
                                    this,
                                    day.Day,
                                    hour.StartHour,
                                    this.props.TimeTable.PhysiotherapistId,
                                    hour.ClinicId
                                )}
                            >
                                <span>{hour.StartHour}</span>
                            </div>
                        ))
                    ) : (
                        <div className="empty-time-table-day">&nbsp;</div>
                    )}
                </div>
            );
            if (day.Hours.length > 0) {
                notEmptyDayPushed = true;
            }
        }

        if (notEmptyDayPushed === false) {
            days = [];
            if (!this.props.TimeTable.HasAnyWorkHours) {
                days.push(this.RenderRequestScheduler());
            } else {
                days.push(
                    <div key={this.props.PhysiotherapistId + '_-1'} className="no-terms-available-info">
                        brak terminów
                    </div>
                );
            }
        }

        return (
            <div
                className={
                    "time-table-component " +
                    (this.state.ShowMore ? "show-more" : "")
                }
            >
                <div className="days">{days}</div>
                {this.RenderMoreButton()}
            </div>
        );
    }

    private RenderMoreButton() {
        const hasMoreItems = this.HasMoreItems();

        if (hasMoreItems || this.state.WindowSize < 768) {
            if (this.state.ShowMore) {
                return (
                    <div
                        className={`more-button ${hasMoreItems ? "" : "no-more-items"}`}
                        onClick={this.OnLessButtonClick}
                    >
                        mniej terminów
                    </div>
                );
            } else {
                return (
                    <div
                        className={`more-button ${hasMoreItems ? "" : "no-more-items"}`}
                        onClick={this.OnMoreButtonClick}
                    >
                        więcej terminów
                    </div>
                );
            }
        } else {
            return null;
        }
    }

    private HasMoreItems(): boolean {
        for (let day of this.props.TimeTable.TimeTableDay) {
            if (day.Hours.length > this.props.MaxDayLength) {
                return true;
            }
        }

        return false;
    }

    private OnHourClick(
        date: Date,
        hour: string,
        physiotherapistId: string,
        clinicId: number | undefined,
        evt
    ) {
        let dateTime = moment(
            date.toLocaleDateString("pl-PL") + " " + hour,
            "DD.MM.YYYY HH:mm"
        ).toDate();
        this.props.OnHourClick(dateTime, physiotherapistId, clinicId);
    }

    private OnMoreButtonClick(e) {
        this.setState({
            ShowMore: true
        });
    }

    private OnLessButtonClick(e) {
        this.setState({
            ShowMore: false
        });
    }

    private RenderRequestScheduler() {
        return (
            <div className="request-scheduler">
                <div
                    className="request-scheduler-btn"
                    onClick={this.OnRequestSchedulerActivationClick}
                >
                    Kliknij, aby poprosić o włączenie kalendarza
                </div>
            </div>
        );
    }

    private OnRequestSchedulerActivationClick(e) {
        const service = new SchedulerService();
        service.RequestSchedulerActivation(
            this.props.PhysiotherapistId,
            success => {
                ShowStatusBar(
                    "Success",
                    "Wysłano powiadomienie",
                    DEFAULT_STATUS_TIMEOUT
                );
            },
            error => {
                ShowStatusBar(
                    "Error",
                    "Nie udało się wysłać powiadomienia",
                    DEFAULT_STATUS_TIMEOUT
                );
            }
        );
    }

    private handleResize = () => {
        this.setState({
            WindowSize: window.innerWidth
        });
    };
}



// WEBPACK FOOTER //
// ./src/controls/TimeTable.tsx